import { useCallback, useRef } from 'react'

import { DailyInspirationCommentRef } from './DailyInspirationCommentSheet'

export const useDailyInspirationCommentSheet = () => {
  const dailyInspirationCommentSheetRef = useRef<DailyInspirationCommentRef>(null)

  const openDailyInspirationCommentSheet = useCallback(() => {
    dailyInspirationCommentSheetRef.current?.openModal()
  }, [])

  const closeDailyInspirationCommentSheet = useCallback(() => {
    dailyInspirationCommentSheetRef.current?.closeModal()
  }, [])

  return {
    dailyInspirationCommentSheetRef,
    closeDailyInspirationCommentSheet,
    openDailyInspirationCommentSheet
  }
}
